import React from 'react';

const Svg = (): React.ReactElement => {
  return (
    <svg width="289" height="140" viewBox="0 0 289 140" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.5"
        d="M4.21512 61.2595C6.46446 61.2595 8.2879 59.436 8.2879 57.1867C8.2879 54.9373 6.46446 53.1139 4.21512 53.1139C1.96578 53.1139 0.142334 54.9373 0.142334 57.1867C0.142334 59.436 1.96578 61.2595 4.21512 61.2595Z"
        fill="#0090FF"
      />
      <path
        d="M75.2626 35.9177C76.7621 35.9177 77.9778 34.7021 77.9778 33.2025C77.9778 31.7029 76.7621 30.4873 75.2626 30.4873C73.763 30.4873 72.5474 31.7029 72.5474 33.2025C72.5474 34.7021 73.763 35.9177 75.2626 35.9177Z"
        fill="#0090FF"
      />
      <path
        d="M48.7534 6.33544C50.5029 6.33544 51.9211 4.91721 51.9211 3.16772C51.9211 1.41824 50.5029 0 48.7534 0C47.0039 0 45.5857 1.41824 45.5857 3.16772C45.5857 4.91721 47.0039 6.33544 48.7534 6.33544Z"
        fill="#0090FF"
      />
      <path
        d="M57.1613 73.0253C58.161 73.0253 58.9715 72.2149 58.9715 71.2152C58.9715 70.2155 58.161 69.405 57.1613 69.405C56.1616 69.405 55.3512 70.2155 55.3512 71.2152C55.3512 72.2149 56.1616 73.0253 57.1613 73.0253Z"
        fill="#0090FF"
      />
      <path
        opacity="0.1"
        d="M131.377 6.05067C132.376 6.05067 133.187 5.24025 133.187 4.24055C133.187 3.24084 132.376 2.43042 131.377 2.43042C130.377 2.43042 129.566 3.24084 129.566 4.24055C129.566 5.24025 130.377 6.05067 131.377 6.05067Z"
        fill="#0090FF"
      />
      <path
        opacity="0.2"
        d="M29.1044 116.468C31.6036 116.468 33.6297 114.442 33.6297 111.943C33.6297 109.444 31.6036 107.418 29.1044 107.418C26.6051 107.418 24.579 109.444 24.579 111.943C24.579 114.442 26.6051 116.468 29.1044 116.468Z"
        fill="#0090FF"
      />
      <path
        d="M105.991 128.234C108.49 128.234 110.516 126.208 110.516 123.709C110.516 121.21 108.49 119.184 105.991 119.184C103.492 119.184 101.466 121.21 101.466 123.709C101.466 126.208 103.492 128.234 105.991 128.234Z"
        fill="#0090FF"
      />
      <path
        d="M177.987 140C179.737 140 181.155 138.582 181.155 136.832C181.155 135.083 179.737 133.665 177.987 133.665C176.238 133.665 174.82 135.083 174.82 136.832C174.82 138.582 176.238 140 177.987 140Z"
        fill="#0090FF"
      />
      <path
        d="M284.332 111.038C286.831 111.038 288.857 109.012 288.857 106.513C288.857 104.013 286.831 101.987 284.332 101.987C281.833 101.987 279.807 104.013 279.807 106.513C279.807 109.012 281.833 111.038 284.332 111.038Z"
        fill="#0090FF"
      />
      <path
        d="M248.13 69.405C249.129 69.405 249.94 68.5946 249.94 67.5949C249.94 66.5952 249.129 65.7848 248.13 65.7848C247.13 65.7848 246.32 66.5952 246.32 67.5949C246.32 68.5946 247.13 69.405 248.13 69.405Z"
        fill="#0090FF"
      />
      <path
        opacity="0.5"
        d="M214.686 57.6392C216.686 57.6392 218.307 56.0183 218.307 54.0189C218.307 52.0195 216.686 50.3987 214.686 50.3987C212.687 50.3987 211.066 52.0195 211.066 54.0189C211.066 56.0183 212.687 57.6392 214.686 57.6392Z"
        fill="#0090FF"
      />
      <path
        opacity="0.8"
        d="M280.712 14.1963C283.211 14.1963 285.237 12.1702 285.237 9.67095C285.237 7.17168 283.211 5.14563 280.712 5.14563C278.213 5.14563 276.187 7.17168 276.187 9.67095C276.187 12.1702 278.213 14.1963 280.712 14.1963Z"
        fill="#0090FF"
      />
      <path
        d="M214.19 12.386C216.439 12.386 218.263 10.5626 218.263 8.31326C218.263 6.06393 216.439 4.24048 214.19 4.24048C211.94 4.24048 210.117 6.06393 210.117 8.31326C210.117 10.5626 211.94 12.386 214.19 12.386Z"
        fill="#0090FF"
      />
      <rect x="100" y="16" width="90" height="90" rx="36" fill="#0090FF" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M163.134 51.3847C164.305 52.5563 164.305 54.4558 163.134 55.6274L142.627 76.1335C141.456 77.305 139.556 77.305 138.385 76.1335L125.879 63.6274C124.707 62.4558 124.707 60.5563 125.879 59.3847C127.05 58.2132 128.95 58.2132 130.121 59.3847L140.506 69.7695L158.891 51.3847C160.062 50.2132 161.962 50.2132 163.134 51.3847Z"
        fill="white"
      />
    </svg>
  );
};

export default Svg;
